export const TXTCLI_Enter_PIN = {
  "id": "TXTCLI_Enter_PIN",
  "defaultMessage": "Enter PIN"
} as const;

export const TXTWCL_Please_enter_your_PIN = {
  "id": "TXTWCL_Please_enter_your_PIN",
  "defaultMessage": "Please enter your PIN"
} as const;